import React from 'react';
import { ADMIN_PALETTE } from '../adminDesignSystem';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function formatEur(value) {
  const n = Number(value || 0);
  return `€${n.toLocaleString('en-IE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatMonth(monthKey) {
  if (!monthKey) return '—';
  const [y, m] = monthKey.split('-');
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString('en-GB', {
    month: 'long',
    year: 'numeric',
  });
}

export function StatusPill({ status }) {
  const map = {
    reportable: { bg: '#FEE2E2', color: '#991B1B', label: 'DAC7 REPORTABLE' },
    approaching: { bg: '#FEF3C7', color: '#92400E', label: 'Approaching' },
    below: { bg: '#DCFCE7', color: '#166534', label: 'Below threshold' },
  };
  const s = map[status] || map.below;
  return (
    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 999, background: s.bg, color: s.color, fontWeight: 700, letterSpacing: 0.4 }}>
      {s.label}
    </span>
  );
}

export function MyDataBadge({ status, mark }) {
  const cfg = {
    submitted: { bg: '#DCFCE7', color: '#166534', label: mark ? `myDATA ✓ ${mark}` : 'myDATA ✓' },
    pending:   { bg: '#FEF3C7', color: '#92400E', label: 'myDATA pending' },
    rejected:  { bg: '#FEE2E2', color: '#991B1B', label: 'myDATA rejected' },
    error:     { bg: '#FEE2E2', color: '#991B1B', label: 'myDATA error' },
    skipped:   { bg: '#F3F4F6', color: '#6B7280', label: 'myDATA N/A' },
    not_applicable: { bg: '#F3F4F6', color: '#6B7280', label: 'myDATA N/A' },
  };
  const c = cfg[status] || cfg.pending;
  return (
    <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 999, background: c.bg, color: c.color, fontWeight: 700, letterSpacing: 0.3 }}>
      {c.label}
    </span>
  );
}

export function StatCard({ icon: Icon, label, value, tone = 'info', testid }) {
  const tones = {
    info: { bg: '#EEF2FF', color: '#3730A3' },
    warn: { bg: '#FEF3C7', color: '#92400E' },
    danger: { bg: '#FEE2E2', color: '#991B1B' },
    ok: { bg: '#DCFCE7', color: '#166534' },
  };
  const t = tones[tone] || tones.info;
  return (
    <div data-testid={testid} style={{ flex: '1 1 160px', minWidth: 160, padding: 14, borderRadius: 14, background: ADMIN_PALETTE.surface, border: `1px solid ${ADMIN_PALETTE.border}`, display: 'flex', gap: 10, alignItems: 'center' }}>
      <div style={{ width: 36, height: 36, borderRadius: 10, background: t.bg, color: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon size={18} />
      </div>
      <div>
        <div style={{ fontSize: 11.5, color: ADMIN_PALETTE.inkMuted, letterSpacing: 0.4, textTransform: 'uppercase' }}>{label}</div>
        <div style={{ fontSize: 20, fontFamily: "'Inria Serif', serif", color: ADMIN_PALETTE.ink, fontWeight: 700 }}>{value}</div>
      </div>
    </div>
  );
}
